import { Component, Input, OnInit } from '@angular/core';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { NavService } from '@shared/services/nav.service';
import { SessionService } from '@shared/services/session.service';
import { AuthService } from '@shared/services/auth.service';
import { UserProfileService } from '@shared/services/user-profile.service';

@Component({
  selector: 'aaos-overview-page',
  templateUrl: './overview-page.component.html',
  styleUrls: ['./overview-page.component.scss']
})
export class OverviewPageComponent implements OnInit {

  @Input() enrollmentPeriodActive = true;
  @Input() oitePeriod = true;
  @Input() residentCurriculum = true;
  editPrivileges = false;
  showLearnMore = false;
  enrollmentBeginDate: Date;
  enrollmentEndDate: Date;
  transitionEndDate: Date;

  constructor(
    private enrollmentService: EnrollmentService,
    private navService: NavService,
    private authService: AuthService,
    private sessionService: SessionService,
    private userProfileService: UserProfileService
  ) { }

  ngOnInit() {
    this.enrollmentService.getOverViewModel(this.sessionService.getInstitutionId()).subscribe(x => {
      this.enrollmentPeriodActive = x.enrollmentPeriodActive;
      this.enrollmentBeginDate = x.enrollmentBeginDate;
      this.enrollmentEndDate = x.enrollmentEndDate;
      this.transitionEndDate = x.transitionEndDate;
      this.oitePeriod =
        this.userProfileService.getOiteProduct(x)?.enabled &&
        this.userProfileService.getOiteProduct(x)?.seatAssignmentPeriodActive;
      this.residentCurriculum = this.userProfileService.getResidentCurriculum(x)?.enabled;
    });
    this.editPrivileges = this.authService.changeAuthorized();

  }

  goToRoster() {
    this.navService.goToRoster();
  }

  goToOITE() {
    this.navService.goToOITE();
  }

  goToFaculty() {
    this.navService.goToFaculty();
  }


}
